"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _AppBar = _interopRequireDefault(require("@material-ui/core/AppBar"));
var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));
var _Tabs = _interopRequireDefault(require("@material-ui/core/Tabs"));
var _Tab = _interopRequireDefault(require("@material-ui/core/Tab"));
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _SttMenuModulos = _interopRequireDefault(require("../../SttMenuModulos"));
var _SttText = _interopRequireDefault(require("../../SttTypography/SttText"));
var _common = require("../../imagens/icones-modulos/common");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    tituloModulo: {
      marginLeft: theme.spacing(1),
      color: theme.palette.background["default"],
      fontSize: '1.25rem',
      letterSpacing: '0.0125em'
    },
    navigationBar: {
      width: '80%'
    },
    toolbar: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      boxShadow: 'none',
      padding: '0'
    },
    leftSection: {
      marginLeft: theme.spacing(2),
      display: 'flex',
      alignItems: 'center'
    },
    centerSection: {
      position: 'absolute',
      left: '50%',
      transform: 'translateX(-50%)',
      whiteSpace: 'nowrap'
    },
    rightSection: {
      marginRight: theme.spacing(1.5),
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto'
    },
    iconeModulo: {
      width: 25,
      height: 25
    },
    indicator: {
      display: 'none'
    }
  };
});
var useStylesTab = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      color: theme.palette.background["default"],
      '&$selected': {
        color: theme.palette.background["default"],
        borderBottom: '4px solid'
      },
      '&$selected $wrapper': {
        marginBottom: '-4px'
      },
      minWidth: 'auto'
    },
    selected: {},
    wrapper: {}
  };
});
var useStylesTabContainer = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      height: 30
    }
  };
});
var iconesModulos = (0, _common.importIconesModulos)();
var MainNavigationBar = function MainNavigationBar(props) {
  var classes = useStyles();
  var classesTab = useStylesTab();
  var classesTabContainer = useStylesTabContainer();
  var submenus = props.submenus,
    _props$selectedTab = props.selectedTab,
    selectedTab = _props$selectedTab === void 0 ? 0 : _props$selectedTab,
    config = props.config,
    _props$mostrarMenuApl = props.mostrarMenuAplicativos,
    mostrarMenuAplicativos = _props$mostrarMenuApl === void 0 ? true : _props$mostrarMenuApl;
  var renderItem = function renderItem(item, index) {
    return /*#__PURE__*/_react["default"].createElement(_Tab["default"], {
      key: index,
      value: index,
      label: item.text,
      onClick: function onClick(e) {
        item.onClick(item, e);
      },
      classes: classesTab,
      disableRipple: true,
      "aria-controls": "menu"
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_Box["default"], null, /*#__PURE__*/_react["default"].createElement(_AppBar["default"], {
    position: "static"
  }, /*#__PURE__*/_react["default"].createElement(_Toolbar["default"], {
    className: classes.toolbar
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.leftSection
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: classes.iconeModulo,
    src: iconesModulos[config.modulo_sigla]
  }), /*#__PURE__*/_react["default"].createElement(_SttText["default"], {
    className: classes.tituloModulo
  }, config.modulo_nome)), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.centerSection
  }, submenus && /*#__PURE__*/_react["default"].createElement(_Tabs["default"], {
    value: selectedTab,
    variant: "scrollable",
    classes: classesTabContainer,
    TabIndicatorProps: {
      className: classes.indicator
    }
  }, submenus.map(renderItem))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.rightSection
  }, mostrarMenuAplicativos && /*#__PURE__*/_react["default"].createElement(_SttMenuModulos["default"], {
    config: config
  })))));
};
var _default = MainNavigationBar;
exports["default"] = _default;